// BLACKJACK-FIXRES
// ===================

/* global window, setTimeout, fetch, console */

import mergeObject from './merge-object';
import status from './status';
import polyfill from './polyfill';
import expandVideo from './expand-video';
import livestream from './livestream';
import modalContent from './modal-content';
import controller from './football-match-header-controller';
import view from './football-match-header-view';

// INITIALISE COMPONENT
// @param rootElement {htmlNode} root dom element of component
// @param options {object} object of optional parameters for component
export default function(rootElement, options) {
  expandVideo(rootElement);
  livestream(rootElement);
  modalContent();

  // set component defaults;
  const defaults = {
    // url endpoint of json data
    url: null,
    // refresh interval in seconds
    interval: 15,
    // url of fetch polyfill
    fetchPolyfill: 'https://cdnjs.cloudflare.com/polyfill/v3/polyfill.min.js?features=fetch,Promise'
  };

  // function to request data using fetch api
  // ensure this is polyfilled for non supporting browsers
  function requestData() {
    // recall request data on the specified interval, converting seconds to milliseconds
    setTimeout(requestData, defaults.interval * 1000);

    // update url
    defaults.url = rootElement.getAttribute('data-url');

    // if no url, bail out
    if (!defaults.url) {
      return;
    }

    // request json data using fetch
    fetch(defaults.url)
      .then(status)
      .then(response => response.json())
      .then(controller.bind(null, rootElement, view))
      // eslint-disable-next-line  no-console
      .catch(error => console.error(error));
  }

  // merge passed options into defaults
  mergeObject(defaults, options);

  // make first request...
  // (polyfill the fetch api if not available)
  polyfill('fetch' in window, defaults.fetchPolyfill, () => {
    requestData();
  });
}
